// import axios from 'axios';
// import { API_BASE_URL } from '../../utils/urls'; // Make sure this path points to your urls.js file

// export const trackOnboardingEvent = (eventName, metadata = {}) => {
//     const token = localStorage.getItem("token"); // Or however you store your auth token
    
//     if (!token) return;

//     // Use fire-and-forget fetch. No need to await or handle UI changes based on tracking.
//     fetch('/api/onboarding/events', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}`
//         },
//         body: JSON.stringify({ event_name: eventName, metadata })
//     }).catch(err => {
//         // Silently fail if analytics request drops (avoids breaking user experience)
//         console.warn("Analytics tracking failed", err);
//     });
// };


import axios from 'axios';
import { API_BASE_URL } from '../../utils/urls'; // Make sure this path points to your urls.js file

export const trackOnboardingEvent = async (eventName, eventData = {}) => {
    try {
        const token = localStorage.getItem('token');
        
        // Don't attempt to track if the user isn't logged in yet
        if (!token) return; 

        // Uses your centralized API_BASE_URL (Port 5000) instead of localhost:3000
        await axios.post(`${API_BASE_URL}/onboarding/events`, {
            event_name: eventName,
            event_data: eventData
        }, {
            headers: { Authorization: `Bearer ${token}` }
        });
        
    } catch (error) {
        // We log it, but don't break the app if analytics fail
        console.warn("Analytics tracking skipped (non-fatal):", error.message);
    }
};